var render = function render(){var _vm=this,_c=_vm._self._c;return _c('typeahead',{attrs:{"value":_vm.inputValue,"results":_vm.results,"loading":_vm.loading,"no-results":_vm.noResults,"type":_vm.type,"placeholder":"Start typing a city, province, or state"},on:{"input":_vm.fetchResults,"select":_vm.onSelect}})
}
var staticRenderFns = []

export { render, staticRenderFns }